<template>
  <div>
    <page-content-header
      v-if='hasContentHeader'
      :item="item"
    />
    <section class="content-section">
      <b-container>
        <b-row>
          <b-col>
            <page-content-creator
              :itemid="itemid"
              pos="top"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <node-element-local-tasks
              v-if="itemid"
              :itemid="itemid"
            />
            <div
              v-if="notpublished"
              class="messages warning"
            >Not published</div>
            <page-content-wysiwg-content
              v-if="itemid"
              :item="item"
            />
            <div
              class="page-content-type-page_content_group node-type-page_content_group"
            >
              <div
                v-if="itemid"
                class="page-content-group"
              >
                <div
                  v-for="(groupitem, key) in list"
                  :key="key"
                  :class="`content-multigroup-wrapper content-multigroup-${key} content-multigroup-delta-${key} content-multigroup-${specialRowClass(key)}`"
                >
                  <div
                    :class="`field-item ${specialRowClass(key)}`"
                    class="teaser-list-item"
                  >
                    <div
                      :class="alignorient"
                      class="teaser"
                    >
                      <content-group-image
                        :groupitem="groupitem"
                        :orientation="orient"
                      />
                      <content-group-details
                        :groupitem="groupitem"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <page-content-creator
              :itemid="itemid"
              pos="bottom"
            />
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>

import ContentGroupImage from './content-group-image'
import ContentGroupDetails from './content-group-details'
import {asyncData, pageMixin} from '../content-type-page-content-group'

export default {
  // Content type uses underscores, linter wants kebab-case!
  // eslint-disable-next-line vue/name-property-casing
  name: 'page-content-type-page_content_group',
  components: {
    'content-group-image': ContentGroupImage,
    'content-group-details': ContentGroupDetails
  },
  asyncData: (args) => {
    return asyncData(args)
  },
  mixins: [
    pageMixin
  ],
  methods: {
    specialRowClass: function(delta) {
      let specialClasses = []
      specialClasses.push(delta % 2 === 0 ? 'even' : 'odd')
      return specialClasses
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
//css for content group page layout

.content-section {
  padding: 3em 0em;
}

//css for the content group teasers
.teaser-list-item {
  border-top: 1px solid;
  border-color: $border-color;
}
.teaser {
  @include media-breakpoint-down(sm) {
    flex-direction: column;
  }
  display: flex;
  flex-direction: row;
  padding: 3em 0em;
  @include media-breakpoint-up(sm) {
    &.right {
      flex-direction: row-reverse;
    }
  }
}

.content-skeleton {
  background: #eef1f5;
  width: 100%;
  min-height: 800px;
  padding-top: 30%;
}
</style>
